import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BellSchedulePeriodsComponent } from "../shared/bell-schedule-periods/bell-schedule-periods.component";
import { BellScheduleRequestModel } from "../shared/BellScheduleRequestModel";
import { DataService_BellScheduleSetup } from "../shared/data.service";
import { PeriodModel } from "../shared/PeriodModel";
import * as moment from "moment";

@Component({
	selector: "caass-school-edit-bell-schedule",
	templateUrl: "./school-edit-bell-schedule.component.html",
	styleUrls: ["./school-edit-bell-schedule.component.css"],
})
export class SchoolEditBellScheduleComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private BellScheduleSetupService: DataService_BellScheduleSetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.BellScheduleID = this.dialogConfig.data.BellScheduleID;
		this.BellScheduleDesc = this.dialogConfig.data.BellScheduleDesc;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//INSERT LOAD COMBO BOX DATA
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	BellScheduleID: any;
	SchoolID: any;

	//INSERT FORM DATA
	BellScheduleDesc: any = "";

	@ViewChild(BellSchedulePeriodsComponent)
	tableRef: BellSchedulePeriodsComponent;

	PeriodList: any = [];

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	//INSERT LOAD DATA METHODS

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onEditBellSchedule() {
		//Create parms
		let PList: PeriodModel[] = [];

		for (var i = 0; i < this.tableRef.lstPeriod.length; i++) {
			var next = this.tableRef.lstPeriod[i];

			let nextPeriod: PeriodModel = {
				PeriodID: next.PeriodID,
				StartTime: "1900-01-01T" + moment(next.StartTimeDate).format("HH:mm:00"),
				EndTime: "1900-01-01T" + moment(next.EndTimeDate).format("HH:mm:00"),
				TardyTime: "1900-01-01T" + moment(next.TardyTimeDate).format("HH:mm:00"),
			};

			PList = [...PList, nextPeriod];
		}

		let parms: BellScheduleRequestModel = {
			BellScheduleID: this.BellScheduleID,
			SchoolID: this.SchoolID,
			BellScheduleDesc: this.BellScheduleDesc,
			PeriodList: PList,
		};

		var result = this.BellScheduleSetupService.EditBellSchedule(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Bell Schedule was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Bell Schedule",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Events
	///////////////////////////////////////

	onListChanged(val) {
		this.PeriodList = val;
	}

	///////////////////////////////////////
}
